import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MarketService } from 'src/app/providers/services/market.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeComponent implements OnInit {
  show: boolean = false;

  constructor(
    private marketService: MarketService
  ) { }

  async ngOnInit(): Promise<void> {
    await this.marketService.getMarkets();
    this.show = true;
  }

}
